// 環境判定ユーティリティ

/**
 * 現在の環境を判定する
 * @returns {string} 'development' | 'staging' | 'production'
 */
export function getEnvironment() {
  if (typeof window !== 'undefined' && window.APP_ENV) {
    return window.APP_ENV;
  }
  
  if (typeof document !== 'undefined') {
    const envMeta = document.querySelector('meta[name="environment"]');
    if (envMeta && envMeta.content) {
      return envMeta.content;
    }
  }
  
  return 'development';
}

/**
 * staging環境かどうかを判定する
 * @returns {boolean}
 */
export function isStaging() {
  return getEnvironment() === 'staging';
}

/**
 * production環境かどうかを判定する
 * @returns {boolean}
 */
export function isProduction() {
  return getEnvironment() === 'production';
}

/**
 * development環境かどうかを判定する
 * @returns {boolean}
 */
export function isDevelopment() {
  return getEnvironment() === 'development';
}
